// eslint-disable-next-line import/no-cycle
import { adminApi } from '@/includes/contentManagementApi';

const levelManagementService = {
  async getUserLevels() {
    const response = await adminApi.get('/user-level-progress/progress');
    return response.data;
  },
  async getSpecificLevel() {
    const response = await adminApi.get('/user-level-progress/currentLevel');
    return response.data;
  },
  async getMySummary() {
    const response = await adminApi.get('/user-level-progress/my-summary');
    return response.data;
  },
  async getDashboard() {
    const response = await adminApi.get('/user-level-progress/dashboard');
    return response.data;
  },
  async getProgressOverview() {
    const response = await adminApi.get('/user-level-progress/progress-overview');
    return response.data;
  },
  async getLevelSystemConfig() {
    const response = await adminApi.get('/config/level-system');
    const data = response?.data?.data ?? response?.data;
    return data || {};
  },
  async updateGoalStatus(goalId, progress) {
    const response = await adminApi.put(`/user-level-progress/goal/${goalId}`, { progress });
    return response.data;
  },
};

export default levelManagementService;
